export function getNavItemColors({ mode, selected, disabled }) {
  if (selected) {
    // Template: selected items use the accent color for icon + label.
    const accent = mode === "dark" ? "#A363F3" : "#7C3AED";
    return {
      container: accent,
      icon: accent,
      text: accent,
    };
  }

  if (disabled) {
    const muted =
      mode === "dark" ? "rgba(181,184,212,0.45)" : "#BDBDCA";
    return {
      container: muted,
      icon: muted,
      text: muted,
    };
  }

  return {
    container: mode === "dark" ? "text.primary" : "#52525B",
    icon: mode === "dark" ? "text.secondary" : "#71717A",
    text: mode === "dark" ? "text.primary" : "#52525B",
  };
}
